/**
 * @param {UserExchangeGift} form
 * @returns {UserExchangeGift}
 */
export function initUserExchangeGift(form) {
    form = {
        ...(form || {}),

        _id: form?._id,

        _gifter: form?._gifter,
        gifter: form?.gifter,

        _giftee: form?._giftee,
        giftee: form?.giftee,

        _bulk: form?._bulk,
        bulk: form?.bulk,

        phone: form?.phone || null,
        count: form?.count || 0,
        amount: form?.amount || 0,

        done: form?.done ?? false,
        fail: form?.fail ?? false,

        undone: form?.undone ?? false,
        cashed: form?.cashed ?? false,
        failedToCash: form?.failedToCash ?? false,

        createdAt: form?.createdAt,
        updatedAt: form?.updatedAt,
    };

    if (!form._id) delete form._id;

    if (!form._gifter) delete form._gifter;
    if (!form.gifter) delete form.gifter;

    if (!form._giftee) delete form._giftee;
    if (!form.giftee) delete form.giftee;

    if (!form._bulk) delete form._bulk;

    if (!form.createdAt) delete form.createdAt;
    if (!form.updatedAt) delete form.updatedAt;

    return form;
}

/**
 * @typedef UserExchangeGift
 *
 * @property {string} [_id]
 *
 * @property {string} [_gifter]
 * @property {object} [gifter]
 *
 * @property {string} [_giftee]
 * @property {object} [giftee]
 *
 * @property {string} [_bulk]
 * @property {import('./').UserExchangeBulk} [bulk]
 *
 * @property {string|null} phone
 * @property {number} count
 * @property {number} amount
 *
 * @property {boolean} done
 * @property {boolean} fail
 *
 * @property {boolean} undone
 * @property {boolean} cashed
 * @property {boolean} failedToCash
 *
 * @property {string} [createdAt]
 * @property {string} [updatedAt]
 */
